import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import moment from "moment";
import {
  formatWithLeadingZeros,
  getTitleByKey,
  getValueText,
  getMihr,
  getKmhr,
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getPaceTextinPaces,
} from "src/utils/constant";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentSettingState";

const WorkoutExercisesHistoryUI = ({ addArray, setaddArray, notForModel }) => {
  const { selectedExercise } = useContentSetting();

  const selectedExerciseData = addArray?.find(
    (d) => d?.exercise?._id === selectedExercise,
  );
  const selectedTitle = selectedExerciseData?.exercise?.title || "";

  return (
    <div className="characters">
      {selectedTitle && (
        <div
          style={{
            marginBottom: "10px",
            padding: "8px 12px",
            borderLeft: "3px solid var(--portal-theme-primary)",
            borderRadius: "4px",
            background: "var(--sidebars-background-color, rgba(0,0,0,0.04))",
          }}
        >
          <Typography
            variant="caption"
            sx={{ opacity: 0.8, fontSize: "11px", display: "block" }}
          >
            Showing history for
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, fontSize: "13px" }}
          >
            {selectedTitle}
          </Typography>
        </div>
      )}

      {addArray?.map((data, mainindex) => (
        <div
          key={mainindex}
          style={{
            width: "100%",
            marginBottom: "12px",
            background: "#fff",
            border: "1px solid #e8e8e8",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Card Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 14px",
              borderBottom: "1px solid #f0f0f0",
              background: "#fafafa",
            }}
          >
            {data?.exercise?.image?.thumbnail_3 ? (
              <Avatar
                sx={{ borderRadius: "6px", width: 30, height: 30 }}
                alt="Exercise"
                src={s3baseUrl + data?.exercise?.image?.thumbnail_3}
              />
            ) : (
              <div
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "6px",
                  background: "#f0f0f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  color: "#999",
                  flexShrink: 0,
                }}
              >
                💪
              </div>
            )}

            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, fontSize: "13px", flex: 1 }}
            >
              {data?.exercise?.title || ""}
            </Typography>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {data?.is_extra && (
                <span
                  style={{
                    fontSize: "10px",
                    padding: "2px 7px",
                    borderRadius: "20px",
                    background: "rgba(255,152,0,0.1)",
                    color: "#e65100",
                    fontStyle: "italic",
                  }}
                >
                  Extra Work
                </span>
              )}
              <Typography
                variant="caption"
                sx={{ fontSize: "11px", opacity: 0.8 }}
              >
                {moment(data?.date).format("DD MMM YYYY")}
              </Typography>
            </div>
          </div>

          {/* Sets */}
          {data?.set?.map((item, index1) => (
            <div
              key={index1}
              style={{
                padding: "10px 14px",
                borderBottom:
                  index1 < data.set.length - 1 ? "1px solid #f5f5f5" : "none",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  opacity: 0.8,
                  display: "block",
                  marginBottom: "8px",
                }}
              >
                Set {index1 + 1}
              </Typography>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {data.parameters.includes("Vdot") && (
                  <>
                    <StatCell label="Auto Pacer" value={item?.vdot} />
                    <StatCell
                      label="Type"
                      value={getValueText(item?.race_type)}
                    />
                    <StatCell
                      label="Pace Type"
                      value={getTitleByKey(item?.pace_type)}
                    />
                    {item?.race_type === "el" ? (
                      <StatCell
                        label={getPaceText(item?.pace_type)}
                        value={`${formatWithLeadingZeros(
                          Math.floor(item?.pace / 60),
                        )}:${formatWithLeadingZeros(item?.pace % 60)}`}
                        unit={`– ${formatWithLeadingZeros(
                          Math.floor(item?.paceUp / 60),
                        )}:${formatWithLeadingZeros(item?.paceUp % 60)}`}
                      />
                    ) : (
                      <StatCell
                        label={getPaceText(item?.pace_type)}
                        value={`${formatWithLeadingZeros(
                          Math.floor(item?.pace / 60),
                        )}:${formatWithLeadingZeros(item?.pace % 60)}`}
                      />
                    )}
                  </>
                )}

                {data.parameters.includes("Pace") && (
                  <>
                    <StatCell
                      label="Type"
                      value={getValueText(item?.race_type)}
                    />
                    <StatCell
                      label="Distance"
                      value={item?.distance || 0}
                      unit={getValueText(item?.distanceType)}
                    />
                    <StatCell
                      label={getPaceTextinPaces(item?.distanceType)}
                      value={`${formatWithLeadingZeros(
                        Math.floor(item?.pace / 60),
                      )}:${formatWithLeadingZeros(item?.pace % 60)}`}
                    />
                  </>
                )}

                {data.parameters.includes("Distance") && (
                  <StatCell
                    label="Distance"
                    value={item?.distance || 0}
                    unit={getValueText(item?.distanceType)}
                  />
                )}

                {(data.parameters.includes("Duration/Pace") ||
                  data.parameters.includes("Time")) && (
                  <StatCell
                    label={
                      data.parameters.includes("Duration/Pace")
                        ? "Duration/Pace"
                        : "Time"
                    }
                    value={item?.time || 0}
                    unit={item?.timeType}
                  />
                )}

                {data.parameters.includes("Reps") && (
                  <StatCell label="Reps" value={item?.reps || 0} />
                )}

                {data.parameters.includes("Max_Reps") && (
                  <StatCell label="Max Reps" value={item?.maxReps || 0} />
                )}

                {data.parameters.includes("Watts") && (
                  <StatCell label="Watts" value={item?.watts || 0} />
                )}

                {data.parameters.includes("Height") && (
                  <StatCell
                    label="Height"
                    value={item?.height || 0}
                    unit={getValueText(item?.height_unit)}
                  />
                )}

                {data.parameters.includes("Weight") && (
                  <StatCell
                    label="Weight"
                    value={item?.weight || 0}
                    unit={getValueText(item?.weightType)}
                  />
                )}

                {data.parameters.includes("Distance/Calories") && (
                  <StatCell
                    label="Distance/Cal"
                    value={item?.distance || 0}
                    unit={getValueText(item?.distanceType)}
                  />
                )}

                {data.parameters.includes("%MHR") && (
                  <StatCell label="%MHR" value={item?.mhr || 0} />
                )}

                {data.parameters.includes("RPE") && (
                  <StatCell label="RPE" value={item?.RPE || 0} />
                )}

                {data.parameters.includes("Tempo") && (
                  <StatCell label="Tempo" value={item?.tempo || 0} />
                )}

                {data.parameters.includes("Rest") && (
                  <StatCell
                    label="Rest"
                    value={item?.rest || 0}
                    unit={item?.restType}
                  />
                )}
              </div>

              {/* Speed string — below all cells */}
              {data.parameters.includes("Vdot") && (
                <div style={{ marginTop: "7px" }}>
                  <Typography
                    variant="caption"
                    sx={{ opacity: 0.8, fontWeight: 600, fontSize: "11px" }}
                  >
                    {item?.race_type === "el"
                      ? `@ Speed ${getKmhr(
                          item?.pace,
                          item?.pace_type,
                        )} u2013 ${getKmhr(
                          item?.paceUp,
                          item?.pace_type,
                        )} km/hr  or  ${getMihr(
                          item?.pace,
                          item?.pace_type,
                        )} u2013 ${getMihr(
                          item?.paceUp,
                          item?.pace_type,
                        )} mi/hr`
                      : `@ Speed ${getKmhr(
                          item?.pace,
                          item?.pace_type,
                        )} km/hr  or  ${getMihr(
                          item?.pace,
                          item?.pace_type,
                        )} mi/hr`}
                  </Typography>
                </div>
              )}
              {data.parameters.includes("Pace") && (
                <div style={{ marginTop: "7px" }}>
                  <Typography
                    variant="caption"
                    sx={{ opacity: 0.8, fontWeight: 600, fontSize: "11px" }}
                  >
                    {`@ Speed ${getKmhrForPace(
                      item?.distance,
                      item?.pace,
                      item?.distanceType,
                    )} km/hr  or  ${getMihrForPace(
                      item?.distance,
                      item?.pace,
                      item?.distanceType,
                    )} mi/hr`}
                  </Typography>
                </div>
              )}
            </div>
          ))}

          {/* Notes */}
          {data?.description && data?.is_extra && (
            <div
              style={{
                margin: "0 14px 12px",
                padding: "8px 10px",
                borderRadius: "6px",
                background: "rgba(145,158,171,0.06)",
                borderLeft: "2px solid rgba(145,158,171,0.25)",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  opacity: 0.8,
                  fontSize: "10px",
                  display: "block",
                  mb: 0.3,
                }}
              >
                Notes
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "12px" }}>
                {data?.description}
              </Typography>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// Stat cell — label on top, value + unit below
const StatCell = ({ label, value, unit }) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === "" ||
    value === 0 ||
    value === "0";

  return (
    <div
      style={{
        background: "rgba(145,158,171,0.07)",
        borderRadius: "8px",
        padding: "7px 10px",
        whiteSpace: "nowrap",
      }}
    >
      <div
        style={{
          fontSize: "10px",
          color: "rgba(0,0,0,0.4)",
          marginBottom: "3px",
          lineHeight: 1.2,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: 600,
          color: isEmpty ? "rgba(0,0,0,0.25)" : "rgba(0,0,0,0.82)",
          lineHeight: 1.3,
        }}
      >
        {isEmpty ? (
          "0"
        ) : (
          <>
            {value}
            {unit && (
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 400,
                  color: "rgba(0,0,0,0.45)",
                  marginLeft: "3px",
                }}
              >
                {unit}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default WorkoutExercisesHistoryUI;
